/**
 * Detects the backend's blocked-customer responses so pages can show the
 * Contact Our Team popup instead of an inline error. Accepts both raw
 * response bodies and axios errors (which nest the body under response.data).
 */
const BLOCKED_CUSTOMER_PATTERNS = [
  /^this customer is blocked\.?$/i,
  /online booking is currently unavailable for this account/i,
];

export const isBlockedCustomerResponse = (response) => {
  const payload = response?.response?.data ?? response;
  const result = typeof payload?.success === 'boolean' ? payload : payload?.data ?? payload;
  const isError = result?.success === false || (
    response?.response?.status >= 400 && result?.success !== true
  );
  if (!isError) return false;
  const message = typeof result?.message === 'string' ? result.message.trim() : '';
  return BLOCKED_CUSTOMER_PATTERNS.some((pattern) => pattern.test(message));
};
